import { zohoIntegrationActionTypes } from '../../actions/integrations/zohoIntegrationActions';

const ZohoIntegrationReducers = (state = { }, action) => {
  switch (action.type) {
  case zohoIntegrationActionTypes.GET_ZOHO_CONNECTIONS.LOADING: {
    const { getZohoConnectionsLoading } = action;
    return {
      ...state,
      getZohoConnectionsLoading,
    };
  }
  case zohoIntegrationActionTypes.GET_ZOHO_CONNECTIONS.SUCCESS: {
    const { zohoConnections } = action;
    return {
      ...state,
      zohoConnections,
    };
  }

  case zohoIntegrationActionTypes.UPDATE_ZOHO_CONNECTION.LOADING: {
    const { updateZohoConnectionLoading } = action;
    return {
      ...state,
      updateZohoConnectionLoading,
    };
  }

  case zohoIntegrationActionTypes.CONNECT_TO_ZOHO.LOADING: {
    const { connectToZohoLoading } = action;
    return {
      ...state,
      connectToZohoLoading,
    };
  }

  case zohoIntegrationActionTypes.CONNECT_TO_ZOHO.SUCCESS: {
    const { connectedToZoho } = action;
    return {
      ...state,
      connectedToZoho,
    };
  }
  
  case zohoIntegrationActionTypes.DELETE_ZOHO_CONNECTION.LOADING: {
    const { deleteZohoConnectionLoading } = action;
    return {
      ...state,
      deleteZohoConnectionLoading,
    };
  }

  case zohoIntegrationActionTypes.DELETE_ZOHO_CONNECTION.SUCCESS: {
    const { deletedZohoConnection } = action;
    return {
      ...state,
      deletedZohoConnection,
    };
  }


  case zohoIntegrationActionTypes.CONNECT_TENANT_TO_LOCATION.LOADING: {
    const { connectTenantToLocationLoading } = action;
    return {
      ...state,
      connectTenantToLocationLoading,
    };
  }

  case zohoIntegrationActionTypes.SYNC_ZOHO_PRODUCT.LOADING: {
    const { syncProductLoading } = action;
    return {
      ...state,
      syncProductLoading,
    };
  }

  case zohoIntegrationActionTypes.SYNC_ZOHO_VENDOR.LOADING: {
    const { syncVendorLoading } = action;
    return {
      ...state,
      syncVendorLoading,
    };
  }

  case zohoIntegrationActionTypes.SYNC_ZOHO_GRN.LOADING: {
    const { syncGRNLoading } = action;
    return {
      ...state,
      syncGRNLoading,
    };
  }

  case zohoIntegrationActionTypes.SYNC_ZOHO_PO.LOADING: {
    const { syncPOLoading } = action;
    return {
      ...state,
      syncPOLoading,
    };
  }

  case zohoIntegrationActionTypes.SYNC_ZOHO_DN.LOADING: {
    const { syncDNLoading } = action;
    return {
      ...state,
      syncDNLoading,
    };
  }
  case zohoIntegrationActionTypes.SYNC_ZOHO_CN.LOADING: {
    const { syncCNLoading } = action;
    return {
      ...state,
      syncCNLoading,
    };
  }
  case zohoIntegrationActionTypes.SYNC_ZOHO_INVOICE.LOADING: {
    const { syncInvoiceLoading } = action;
    return {
      ...state,
      syncInvoiceLoading,
    };
  }

  case zohoIntegrationActionTypes.PULL_ZOHO_PRODUCTS.LOADING: {
    const { pullProductsLoading } = action;
    return {
      ...state,
      pullProductsLoading,
    };
  }

  case zohoIntegrationActionTypes.PULL_ZOHO_VENDORS.LOADING: {
    const { pullVendorsLoading } = action;
    return {
      ...state,
      pullVendorsLoading,
    };
  }
  case zohoIntegrationActionTypes.PULL_ZOHO_CUSTOMERS.LOADING: {
    const { pullCustomersLoading } = action;
    return {
      ...state,
      pullCustomersLoading
    };
  }

  default: {
    return state;
  }
  }
};

export default ZohoIntegrationReducers;
